import {
  buttonNavigationColorInput,
  carouselLayoutInputs,
  ctaInputs,
  navigationArrowInputs,
  tileAppearanceInputs,
} from "~/hec/builder/carousel-options/carousel-options.inputs";
import {
  DEFAULT_NUM_RESULTS,
  MAX_NUM_RESULTS,
} from "~/hec/builder/carousel-options/carousel-options.logic";

export const productCarouselInputs = [
  // ── Core ──────────────────────────────────────────────────────────────
  {
    name: "categoryId",
    type: "string",
    required: true,
    helperText: "SFCC category ID (e.g. 'vitamins-supplements')",
  },
  {
    name: "numResults",
    type: "number",
    defaultValue: DEFAULT_NUM_RESULTS,
    min: 1,
    max: MAX_NUM_RESULTS,
    helperText: `Number of products to fetch (at most ${MAX_NUM_RESULTS}).`,
  },
  {
    name: "addedToCartPodId",
    type: "string",
    helperText:
      "CIO pod ID used for post-ATC recommendations (optional). Passed through for Builder editor parity.",
  },
  ...tileAppearanceInputs,
  ...carouselLayoutInputs,
  buttonNavigationColorInput,
  ...navigationArrowInputs,
  // ── Headline ──────────────────────────────────────────────────────────
  {
    name: "enableHeadline",
    type: "boolean",
    defaultValue: false,
  },
  {
    name: "headlineText",
    type: "string",
    defaultValue: "Explore More",
    showIf: `options.get('enableHeadline') === true`,
  },
  ...ctaInputs,
];
